import React from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import runModal from 'ui-library/runModal';

import CreateRequestV2SubmissionModal from '../modals/CreateRequestV2SubmissionModal';

interface CreateRequestV2SubmissionButtonProps {
  isExpanded: boolean;
}

function handleClickNewRequestV2Submission(): void {
  runModal(CreateRequestV2SubmissionModal, {
    actionOrigin: ActionOrigin.REQUEST_V2_SIDEPANEL,
  });
}

export default function CreateRequestV2SubmissionButton(
  props: CreateRequestV2SubmissionButtonProps
): JSX.Element {
  return (
    <Tooltip text={props.isExpanded ? null : 'Add Request'} placement={FloatingPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="compose"
        onClick={handleClickNewRequestV2Submission}
        size={ButtonSize.SMALL}
        text={props.isExpanded ? 'New Request' : null}
      />
    </Tooltip>
  );
}
